export default "__VITE_ASSET__D4ca6xqS__"